import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseResendContractEnvelopeSignatureEmailsProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useResendContractEnvelopeSignatureEmails = ({
  onSuccess,
  onError,
}: UseResendContractEnvelopeSignatureEmailsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['resendContractEnvelopeSignatureEmails'],
    mutationFn: async (id?: string) => {
      await privateAxios.put(`/funnel/private_company_leads/${id}/resend_contract_signature_emails`)
    },
    onSuccess,
    onError,
  })
}
